import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useInviteUserToOrganization');

    return {
        DELETE_INVITATION_ERROR_MESSAGE: t('deleteInvitationErrorMessage'),
        DELETE_INVITATION_SUCCESS_MESSAGE: t('deleteInvitationSuccessMessage'),
        FETCH_INVITATIONS_ERROR_MESSAGE: t('fetchInvitationsErrorMessage'),
        INVITE_USER_TO_ORGANIZATION_ERROR_MESSAGE: t('inviteUserToOrganizationErrorMessage'),
        INVITE_USER_TO_ORGANIZATION_SUCCESS_MESSAGE: t('inviteUserToOrganizationSuccessMessage')
    };
};

export default useTranslation;
